import React from "react";
import { List } from "material-ui";

import "./index.scss";

const AlternatingList: React.SFC = (props) => {
    return <List className="alternating-list">{props.children}</List>;
};

export default AlternatingList;



// WEBPACK FOOTER //
// ./src/components/AlternatingList/index.tsx